var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{staticClass:"text-center",attrs:{"show":!_vm.loading && _vm.emptyData,"variant":"warning"}},[_vm._v(" "+_vm._s(_vm._f("translate")(_vm.text))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }